import React, { useState, useEffect } from 'react';
import { Form, Button, Container, Row, Col, Card } from 'react-bootstrap';
import { createCanoneMarketplace, getOriginiOrdini } from '../services/api';
import { useNavigate } from 'react-router-dom';

const NuovoCanoneMarketplace = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    denominazione: '',
    percentuale: 0,
    percentuale_include_iva: true,
    costo_fisso: 0,
    origine: '', // NEW
  });
  const [originiOrdini, setOriginiOrdini] = useState([]); // NEW

  useEffect(() => {
    const fetchOrigins = async () => {
        try {
            const response = await getOriginiOrdini();
            setOriginiOrdini(response.data);
        } catch (error) {
            console.error("Errore nel recupero delle origini ordini:", error);
        }
    };
    fetchOrigins();
  }, []);

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    let newValue = value;

    if (type === 'number') {
      newValue = parseFloat(value) || 0;
    }

    setFormData({
      ...formData,
      [name]: newValue
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.denominazione) {
      alert('La denominazione è obbligatoria.');
      return;
    }

    try {
      await createCanoneMarketplace(formData);
      alert('Canone creato con successo!');
      navigate('/canoni-marketplace');
    } catch (error) {
      console.error("Errore nella creazione del canone:", error.response || error);
      alert(`Errore nella creazione del canone: ${error.response?.data?.detail || 'Errore sconosciuto'}`);
    }
  };

  return (
    <Container>
        <Row className="align-items-center mb-3">
            <Col>
                <h2>Nuovo Canone Marketplace</h2>
            </Col>
            <Col xs="auto" className="ms-auto">
                <Button variant="secondary" onClick={() => navigate('/canoni-marketplace')} className="me-2">
                    Indietro
                </Button>
                <Button variant="primary" type="submit" form="canone-new-form">
                    Salva
                </Button>
            </Col>
        </Row>
      <Form id="canone-new-form" onSubmit={handleSubmit}>
        <Card className="mb-4">
          <Card.Header>Dettagli Canone Marketplace</Card.Header>
          <Card.Body>
            <Row className="mb-3">
              <Form.Group as={Col} md={12} controlId="formDenominazione">
                <Form.Label>Denominazione</Form.Label>
                <Form.Control 
                  type="text" 
                  name="denominazione" 
                  value={formData.denominazione} 
                  onChange={handleChange} 
                  placeholder="Es. IBS, FELTRINELLI" 
                  required 
                />
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} md={6} controlId="formPercentuale">
                <Form.Label>Percentuale (%)</Form.Label>
                <Form.Control 
                  type="number" 
                  name="percentuale" 
                  value={formData.percentuale} 
                  onChange={handleChange} 
                  step="0.01"
                  min="0"
                />
              </Form.Group>
              <Form.Group as={Col} md={6} controlId="formCostoFisso">
                <Form.Label>Costo Fisso (€)</Form.Label>
                <Form.Control 
                  type="number" 
                  name="costo_fisso" 
                  value={formData.costo_fisso} 
                  onChange={handleChange} 
                  step="0.01"
                  min="0"
                />
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} md={12} controlId="formPercentualeIva" className="mt-2">
                <Form.Check
                  type="switch"
                  label="La percentuale è comprensiva di IVA (l'IVA sulla commissione è detraibile: la commissione netta è percentuale ÷ 1,22 su articolo + spedizione)"
                  checked={formData.percentuale_include_iva !== false}
                  onChange={(e) => setFormData({ ...formData, percentuale_include_iva: e.target.checked })}
                />
              </Form.Group>
            </Row>
            <Row className="mb-3"> {/* NEW ROW FOR ORIGINE */}
              <Form.Group as={Col} md={6} controlId="formOrigine">
                <Form.Label>Origine</Form.Label>
                <Form.Select 
                  name="origine" 
                  value={formData.origine} 
                  onChange={handleChange}
                >
                  <option value="">Seleziona Origine</option>
                  {originiOrdini.map(origine => (
                    <option key={origine} value={origine}>{origine}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Row>
          </Card.Body>
        </Card>
      </Form>
    </Container>
  );
};

export default NuovoCanoneMarketplace;
